export default __webpack_public_path__ + "static/media/ita_color_rgb_big.e91cf87b.png";